const Retry = ({ className = '' }: { className?: string }) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={`fill-white ${className}`}
  >
    <path d='M1.68164 8C1.68164 9.5913 2.31378 11.1174 3.439 12.2426C4.56422 13.3679 6.09034 14 7.68164 14C9.27497 14 10.8016 13.3733 11.9483 12.2667L10.9483 11.2667C10.5286 11.7111 10.0221 12.0647 9.46021 12.3056C8.89831 12.5464 8.29296 12.6693 7.68164 12.6667C3.52164 12.6667 1.44164 7.64 4.38164 4.7C7.32164 1.76 12.3483 3.84667 12.3483 8H10.3483L13.015 10.6667H13.0816L15.6816 8H13.6816C13.6816 6.4087 13.0495 4.88258 11.9243 3.75736C10.7991 2.63214 9.27294 2 7.68164 2C6.09034 2 4.56422 2.63214 3.439 3.75736C2.31378 4.88258 1.68164 6.4087 1.68164 8Z' />
  </svg>
)

export default Retry
